module.exports = __webpack_public_path__ + "img/icon-button-insert.4269db01.svg";